import React, { useEffect } from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";

const MobileMenu = () => {

  useEffect(() => {
    const verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
          <div id="scrollbar">
            <Container fluid>
              <ul className="navbar-nav" id="navbar-nav">
                <li className="nav-item">
                    <Link className="nav-link menu-link" to="https://www.bankofafrica.ma/">
                        <i className="bx bx-link-external"></i> <span>Site commercial</span>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link menu-link" to="https://scf-bankofafrica.ma/">
                        <i className="bx bx-link-external"></i><span>Supply Chain Finance</span>
                    </Link>
                </li>
              </ul>
            </Container>
          </div>
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default MobileMenu;
